<template>
  <main>
    <header>
      {{ selectedCategory.header }}
    </header>

    <div class="emoji-container">
      <a v-for="(item, index) in displayedEmojis" class="emoji" @click="clickedEmoji(item)" :key="item.annotation" :data-cy="`emoji-${item.emoji}`">
        {{ item.emoji }}
      </a>
    </div>

    <div class="category-container">
      <div class="sb-icon"
        v-for="category in categories"
        :class="{ selected: selectedCategory === category }"
        @click="selectedCategory = category"
        :key="category.header"
        :data-cy="`emoji-category-${category.icon}`"
      >
        <svg :viewBox="category.viewbox">
          <use :xlink:href="'#' + category.icon"></use>
        </svg>
      </div>
    </div>
  </main>
</template>

<script>
import emojiData from '../../../data/emojis.json';
import { groupBy } from '../../../utilities'

export default {
  name: "emoji-grid",

  data() {
    return {
      selectedCategory: null,
      categories: [
        { icon:'smile', header:'smileys & people', viewbox: '0 0 368 368'},
        { icon:'a-flower', header:'animals & nature',  viewbox: '0 0 512 512'},
        { icon:'burger', header:'food & drink', viewbox:'0 0 512 512' },
        { icon:'car', header:'travel & places', viewbox: '0 0 39.055 39.054' },
        { icon:'basketball', header:'activities', viewbox:'0 0 512 512' },
        { icon:'light-bulb', header:'objects', viewbox:'0 0 512 512' },
        { icon:'heart', header:'symbols', viewbox:'0 -28 512.001 512' },
        { icon:'flag', header:'flags', viewbox:'0 0 60 60'}
      ],
      emojis: {}
    }
  },

  created() {
    this.selectedCategory = this.categories[0];
    const groupedEmojis = groupBy(emojiData, 'group');

    Object.entries(groupedEmojis).forEach(([index, group]) => {
      const icon = this.categories[index].icon;
      this.emojis[icon] = group;
    });
  },

  methods: {
    clickedEmoji(item) {
      this.$emit('updated:emoji', item);
    }
  },

  computed: {
    displayedEmojis() {
      return this.emojis[this.selectedCategory.icon];
    }
  }
}
</script>

<style scoped>
  .category-container {
    background-color: rgba(18, 143, 249, 0.15);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-y: auto;
  }

  .sb-icon {
    padding: 0.5em;
    cursor: pointer;
    fill: #5E6469;
  }

  .sb-icon:hover {
    fill: #222222;
  }

  .sb-icon svg {
    width: 26px;
  }

  .sb-icon.selected {
    fill: #128ff9;
  }

  .emoji-container {
    max-height: 10em;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .emoji {
    font-size: 1.5rem;
    padding: 0.2em 0.2em 0 0.2em;
  }

  header {
    font-weight: bold;
    font-size: 16px;
    padding: 0 0.35rem;
  }
</style>
